import React from "react";
import {calculateBackgroundColor} from "helpers/color-calculator";
import {ColorDefinition} from "data/models/shared/recommended-colors3";


type DefinedColorProps = {
  colors: ColorDefinition[];
}

export default function DefinedColors({colors}: DefinedColorProps) {
  return <div className={"flex flex-row gap-0.5 h-full"}>
    {colors.map((color, index) => (
        <div className={"flex flex-col w-full"} key={index}>
          <div
              className={"w-full h-1/4"}
              style={{
                backgroundColor: color.primary
              }}
          />
          <div
              className={"w-full h-1/4"}
              style={{
                backgroundColor: color.secondary
              }}
          />
          <div
              className={"w-full h-1/4"}
              style={{
                backgroundColor: color.accent
              }}
          />
          <div
              className={"w-full h-1/4"}
              style={{
                backgroundColor: calculateBackgroundColor(color.primary)
              }}
          />
        </div>
    ))}
  </div>
}

